import React from 'react';
import styles from './item.module.css';

class itemImg extends React.Component{
   constructor(props){
     super(props);
   }
    render(){
      if(this.props.data){
        return (
          <div>
            <img className={ styles.contentImg} src={this.props.data.content}></img>
              {/* IMG - {this.props.data.content} */}
          </div>
          )
      }else{
        return (
          <div></div>
        )
      }
    }
  }
export default itemImg